import React from "react";
import { useParams } from "react-router-dom";
import InviteManagement from "./InviteManagement";

const OrganizationInvitesPage = () => {
  const { organizationId } = useParams();

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-heading-1">Manage Invites</h1>
        <p className="text-muted-foreground">
          Send and manage user invitations for this organization
        </p>
      </div>
      <InviteManagement organizationId={organizationId} />
    </div>
  );
};

export default OrganizationInvitesPage;
